import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2fddb51e")

_pushScopeId("data-v-2fddb51e")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-image" }
const _hoisted_3 = { class: "image" }
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = {
  class: "title is-5 text-black truncate",
  "data-testid": "title-card"
}
const _hoisted_7 = {
  class: "subtitle is-6 is-blue truncate",
  "data-testid": "url-card"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: '/ctf/' + _ctx.id
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("figure", _hoisted_3, [
            _createVNode("img", {
              src: _ctx.image,
              alt: _ctx.title,
              "data-testid": "url-image"
            }, null, 8, ["src", "alt"])
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.title), 1),
            _createVNode("p", _hoisted_7, [
              _createVNode("a", {
                href: _ctx.url,
                target: "_blank",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
              }, _toDisplayString(_ctx.url), 9, ["href"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
})